import React, {useEffect, useState} from 'react';
import * as Yup from 'yup';
import {Column, Row} from '../../../../../components/layout';
import './styles.scss';
import * as fonts from '../../../../../util/fonts';
import {
  AppForm,
  AppFormSelectField,
  AppFormSubmitButton,
} from '../../../../../components/forms';
import {addToWizard} from '../../../../../store/actions';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../../../../util/strings';

const validationSchema = Yup.object().shape({
  patient: Yup.string().required(),
});

interface PatientValidationProps {
  user: any;
  onSubmit(values: any): any;
  setValid(value: boolean): void;
  nextStep(): void;
  valid: boolean;
  addToWizard(value: any): void;
  labels: typeof strings.pt.createRefund;
  buStyles: any;
  selectedBu: any;
  produtos: any;
}

function PatientValidation({
  valid = true,
  setValid,
  user,
  nextStep,
  addToWizard,
  labels,
  buStyles,
  selectedBu,
  produtos,
}: PatientValidationProps) {
  const [patient, setPatient] = useState(selectedBu.memberName);
  const [patientOptions, setPatientOptions] = useState<any[]>([]);
  const [patients, setPatients] = useState<any[]>([]);
  const [options, setOptions] = useState<any[]>([]);
  const [formikContext, setFormikContext] = useState<any>();

  useEffect(() => {
    async function getPatientOptions() {
      let newPatients: any[] = [];

      setPatientOptions(
        Object.keys(produtos).map((patient: any) => {
          if (
            selectedBu.famId === produtos[patient].famId &&
            selectedBu.buId === produtos[patient].buId
          ) {
            newPatients.push({...produtos[patient]});
            return {
              value: produtos[patient].nif,
              label: produtos[patient].memberName,
            };
          }
        })
      );

      setPatients(newPatients);
    }
    getPatientOptions();
  }, [selectedBu]);

  useEffect(() => {
    const aux = (patients as any).map((item: any) => {
      if (selectedBu.famId === item.famId && selectedBu.buId === item.buId) {
        return {
          value: item.nif,
          label: item.memberName,
        };
      }
    });

    setPatientOptions(aux);

    let filterPatients = aux.filter((x: any) => x !== undefined);
    setOptions(filterPatients);
  }, [patients]);

  useEffect(() => {
    if (formikContext) {
      (formikContext as any).setFieldValue(
        'patient',
        options?.find((elem) => elem.label === selectedBu.memberName)?.value
      );
    }
  }, [options]);

  return (
    <Column className="patient-validation-container">
      <Row className="patient-validation-select-row">
        <h3 style={{...fonts.ML}}>{labels?.createRefund_selectPatient}</h3>
      </Row>
      <AppForm
        className="patient-validation-form-container"
        initialValues={{
          patient: patient,
        }}
        validationSchema={validationSchema}
        onValidation={(valid) => setValid(valid)}
        onChange={(values: any) => {
          if (values.patient !== patient && values.patient !== undefined) {
            setValid(true);
            setPatient(values.patient);
          }
        }}
        onSubmit={(values) => {
          const patientValidation = {
            ...patients.find((elem) => elem.nif === values.patient),
            patients,
          };

          addToWizard({patientValidation});
          nextStep();
        }}>
        <Column className="patient-validation-box-column">
          <Row className="patient-validation-dropdown-row">
            <AppFormSelectField
              name={'patient'}
              options={[...options]}
              inputStyle={{color: buStyles?.primaryColor}}
              defaultValue={selectedBu.memberName}
              handleFormikContext={(formik) => {
                if (!!!formikContext) {
                  setFormikContext(formik);
                }
              }}
            />
          </Row>
        </Column>
        <Row className="patient-validation-continue-button-row">
          <AppFormSubmitButton
            title={labels?.createRefund_confirm}
            disabled={!valid}
            className="stepper-continue-button"
          />
        </Row>
      </AppForm>
    </Column>
  );
}

const mapStateToProps = ({
  user,
  wizard,
  strings,
  globalStyles,
  selectedBu,
  produtos,
}: any) => ({
  user: user.value,
  wizard: wizard.value,
  labels: strings.value.pt.createRefund,
  buStyles: globalStyles.value,
  selectedBu: selectedBu.value,
  produtos: produtos.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(PatientValidation)
);
